/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CreateGidApproverWorkflowStep } from '@coin/shared/core/util-models-v2';
import { CreatePositionRequestWorkflowFactoryRule } from '@coin/shared/core/util-models-v2';
import { CreateWorkflowFactory } from '@coin/shared/core/util-models-v2';
import { EntitySearchScope } from '@coin/shared/core/util-models-v2';
import { PageOfWorkflowFactory } from '@coin/shared/core/util-models-v2';
import { PageOfWorkflowFactoryRule } from '@coin/shared/core/util-models-v2';
import { PageOfWorkflowStep } from '@coin/shared/core/util-models-v2';
import { PositionRequestWorkflowFactoryRule } from '@coin/shared/core/util-models-v2';
import { UpdateGidApproverWorkflowStep } from '@coin/shared/core/util-models-v2';
import { UpdatePositionRequestWorkflowFactoryRule } from '@coin/shared/core/util-models-v2';
import { UpdateWorkflowFactory } from '@coin/shared/core/util-models-v2';
import { WorkflowFactory } from '@coin/shared/core/util-models-v2';
import { WorkflowStep } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface CreateGidApproverWorkflowStepWorkflowStepsParams {
  type: string;
  /** The display name and GIDs to create the workflow-step with. */
  createGidApproverWorkflowStep?: CreateGidApproverWorkflowStep;
}

export interface CreateWorkflowFactoryRuleWorkflowFactoryRulesParams {
  /** The unique id of the workflow-factory to create the workflow-factory-rule for. */
  workflowFactoryId: string;
  /** The data to create the workflow-factory-rule with. */
  body?: CreatePositionRequestWorkflowFactoryRule;
}

export interface CreateWorkflowFactoryWorkflowFactoriesParams {
  /** The data to create the workflow-factory with. */
  createWorkflowFactory?: CreateWorkflowFactory;
}

export interface DeleteGidApproverWorkflowStepWorkflowStepsParams {
  /** The unique id of the configured workflow-step to delete. */
  id: string;
  type: string;
}

export interface DeleteWorkflowFactoryRuleWorkflowFactoryRulesParams {
  /** The unique id of the workflow-factory to delete the workflow-factory-rule of. */
  workflowFactoryId: string;
  /** The unique id of the workflow-factory-rule to delete. */
  id: string;
}

export interface DeleteWorkflowFactoryWorkflowFactoriesParams {
  /** The unique id of the workflow-factory to delete. */
  id: string;
}

export interface GetRuleEngineFieldValuesWorkflowFactoryRuleEngineParams {
  /** The type of workflow-factory to get field-values for. */
  workflowFactoryType: 'PositionRequest';
  /** The field to get field-values for. */
  field: string;
}

export interface GetRuleEngineSearchScopeWorkflowFactoryRuleEngineParams {
  /** The type of workflow-factory to get the search scope for. */
  workflowFactoryType: 'PositionRequest';
  /** The optional search query to search for specific scope elements. */
  searchQuery?: string;
}

export interface PageWorkflowFactoriesWorkflowFactoriesParams {
  /** Query all workflow-factories with specific title. */
  titleStartsWith?: string;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface PageWorkflowFactoryRulesWorkflowFactoryRulesParams {
  /** The unique id of the workflow-factory to get a page of workflow-factory-rules of. */
  workflowFactoryId: string;
  /** Query all workflow-factory-rules with titles starting with. */
  titleStartsWith?: string;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface PageWorkflowStepsWorkflowStepsParams {
  type2: string;
  /** The type of workflow-steps to filter for. */
  type?: 'PositionRequest';
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface UpdateGidApproverWorkflowStepWorkflowStepsParams {
  /** The unique id of the configured workflow-step to update. */
  id: string;
  type: string;
  /** The new display name and GIDs. */
  updateGidApproverWorkflowStep?: UpdateGidApproverWorkflowStep;
}

export interface UpdateWorkflowFactoryRuleWorkflowFactoryRulesParams {
  /** The unique id of the workflow-factory to update the workflow-factory-rule of. */
  workflowFactoryId: string;
  /** The unique id of the workflow-factory-rule to update. */
  id: string;
  /** The data to update the workflow-factory-rule with. */
  body?: UpdatePositionRequestWorkflowFactoryRule;
}

export interface UpdateWorkflowFactoryWorkflowFactoriesParams {
  /** The unique id of the workflow-factory to update. */
  id: string;
  /** The data to update the workflow-factory with. */
  updateWorkflowFactory?: UpdateWorkflowFactory;
}

@Injectable({
  providedIn: 'root'
})
export class ApprovalWorkflowsAdminService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * Creates a configured \&#39;GidApprover\&#39; workflow-step whose approvers are an explicit list of GIDs.
   * Every GID must belong to an active user, otherwise the request is rejected naming the invalid entry.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createGidApproverWorkflowStepWorkflowSteps(
    requestParameters?: CreateGidApproverWorkflowStepWorkflowStepsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<WorkflowStep>;
  public createGidApproverWorkflowStepWorkflowSteps(
    requestParameters?: CreateGidApproverWorkflowStepWorkflowStepsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<WorkflowStep>>;
  public createGidApproverWorkflowStepWorkflowSteps(
    requestParameters?: CreateGidApproverWorkflowStepWorkflowStepsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<WorkflowStep>>;
  public createGidApproverWorkflowStepWorkflowSteps(
    requestParameters?: CreateGidApproverWorkflowStepWorkflowStepsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const type = requestParameters?.type;
    this.checkRequired('createGidApproverWorkflowStepWorkflowSteps', { type });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/approval-workflows/workflow-factory/types/${this.configuration.encodeParam({ name: 'type', value: type, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/steps/gid-approver-steps`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createGidApproverWorkflowStep,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Creates a workflow-factory-rule for a workflow-factory.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createWorkflowFactoryRuleWorkflowFactoryRules(
    requestParameters?: CreateWorkflowFactoryRuleWorkflowFactoryRulesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PositionRequestWorkflowFactoryRule>;
  public createWorkflowFactoryRuleWorkflowFactoryRules(
    requestParameters?: CreateWorkflowFactoryRuleWorkflowFactoryRulesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PositionRequestWorkflowFactoryRule>>;
  public createWorkflowFactoryRuleWorkflowFactoryRules(
    requestParameters?: CreateWorkflowFactoryRuleWorkflowFactoryRulesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PositionRequestWorkflowFactoryRule>>;
  public createWorkflowFactoryRuleWorkflowFactoryRules(
    requestParameters?: CreateWorkflowFactoryRuleWorkflowFactoryRulesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const workflowFactoryId = requestParameters?.workflowFactoryId;
    this.checkRequired('createWorkflowFactoryRuleWorkflowFactoryRules', { workflowFactoryId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/approval-workflows/workflow-factories/${this.configuration.encodeParam({ name: 'workflowFactoryId', value: workflowFactoryId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/rules`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.body,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Creates a workflow-factory.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createWorkflowFactoryWorkflowFactories(
    requestParameters?: CreateWorkflowFactoryWorkflowFactoriesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<WorkflowFactory>;
  public createWorkflowFactoryWorkflowFactories(
    requestParameters?: CreateWorkflowFactoryWorkflowFactoriesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<WorkflowFactory>>;
  public createWorkflowFactoryWorkflowFactories(
    requestParameters?: CreateWorkflowFactoryWorkflowFactoriesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<WorkflowFactory>>;
  public createWorkflowFactoryWorkflowFactories(
    requestParameters?: CreateWorkflowFactoryWorkflowFactoriesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/approval-workflows/workflow-factories`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createWorkflowFactory,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Deletes a configured \&#39;GidApprover\&#39; workflow-step.
   * Rejected while the workflow-step is part of an approval chain or used by a workflow.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteGidApproverWorkflowStepWorkflowSteps(
    requestParameters?: DeleteGidApproverWorkflowStepWorkflowStepsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public deleteGidApproverWorkflowStepWorkflowSteps(
    requestParameters?: DeleteGidApproverWorkflowStepWorkflowStepsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public deleteGidApproverWorkflowStepWorkflowSteps(
    requestParameters?: DeleteGidApproverWorkflowStepWorkflowStepsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public deleteGidApproverWorkflowStepWorkflowSteps(
    requestParameters?: DeleteGidApproverWorkflowStepWorkflowStepsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const type = requestParameters?.type;
    this.checkRequired('deleteGidApproverWorkflowStepWorkflowSteps', { id, type });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/approval-workflows/workflow-factory/types/${this.configuration.encodeParam({ name: 'type', value: type, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/steps/gid-approver-steps/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * Deletes a workflow-factory-rule of a workflow-factory.
   * Will update all workflow-factory-rule priorities to account for the now deleted workflow-factory-rule.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteWorkflowFactoryRuleWorkflowFactoryRules(
    requestParameters?: DeleteWorkflowFactoryRuleWorkflowFactoryRulesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public deleteWorkflowFactoryRuleWorkflowFactoryRules(
    requestParameters?: DeleteWorkflowFactoryRuleWorkflowFactoryRulesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public deleteWorkflowFactoryRuleWorkflowFactoryRules(
    requestParameters?: DeleteWorkflowFactoryRuleWorkflowFactoryRulesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public deleteWorkflowFactoryRuleWorkflowFactoryRules(
    requestParameters?: DeleteWorkflowFactoryRuleWorkflowFactoryRulesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const workflowFactoryId = requestParameters?.workflowFactoryId;
    const id = requestParameters?.id;
    this.checkRequired('deleteWorkflowFactoryRuleWorkflowFactoryRules', { workflowFactoryId, id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/approval-workflows/workflow-factories/${this.configuration.encodeParam({ name: 'workflowFactoryId', value: workflowFactoryId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/rules/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * Deletes a workflow-factory.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteWorkflowFactoryWorkflowFactories(
    requestParameters?: DeleteWorkflowFactoryWorkflowFactoriesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public deleteWorkflowFactoryWorkflowFactories(
    requestParameters?: DeleteWorkflowFactoryWorkflowFactoriesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public deleteWorkflowFactoryWorkflowFactories(
    requestParameters?: DeleteWorkflowFactoryWorkflowFactoriesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public deleteWorkflowFactoryWorkflowFactories(
    requestParameters?: DeleteWorkflowFactoryWorkflowFactoriesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deleteWorkflowFactoryWorkflowFactories', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/approval-workflows/workflow-factories/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * Gets all field-values for the rule-set configuration.
   * Use this together with the search-scope endpoint and same workflow-type to fully configure rule-sets that can be persisted by the rule-engine-api. Readable with the rule-engine\&#39;s own SiemensEnergy.COIN.Users.Contracts.Enums.Resource.RuleSets right as well, since every consumer that may author rule-sets needs these field-values to do so.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getRuleEngineFieldValuesWorkflowFactoryRuleEngine(
    requestParameters?: GetRuleEngineFieldValuesWorkflowFactoryRuleEngineParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<string>>;
  public getRuleEngineFieldValuesWorkflowFactoryRuleEngine(
    requestParameters?: GetRuleEngineFieldValuesWorkflowFactoryRuleEngineParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<string>>>;
  public getRuleEngineFieldValuesWorkflowFactoryRuleEngine(
    requestParameters?: GetRuleEngineFieldValuesWorkflowFactoryRuleEngineParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<string>>>;
  public getRuleEngineFieldValuesWorkflowFactoryRuleEngine(
    requestParameters?: GetRuleEngineFieldValuesWorkflowFactoryRuleEngineParams,
    ...args: RequestArgs
  ): Observable<any> {
    const workflowFactoryType = requestParameters?.workflowFactoryType;
    const field = requestParameters?.field;
    this.checkRequired('getRuleEngineFieldValuesWorkflowFactoryRuleEngine', { workflowFactoryType, field });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/approval-workflows/workflow-factory/types/${this.configuration.encodeParam({ name: 'workflowFactoryType', value: workflowFactoryType, in: 'path', style: 'simple', explode: false, dataType: "'PositionRequest'", dataFormat: undefined })}/rule-engine/field-values/${this.configuration.encodeParam({ name: 'field', value: field, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets the rule-engine search-scope for workflow-factory-rules.
   * Use this to populate the rule-engine dialog with all available fields and types for the specific workflow-type. Readable with the rule-engine\&#39;s own SiemensEnergy.COIN.Users.Contracts.Enums.Resource.RuleSets right as well, since every consumer that may author rule-sets needs this field metadata to do so.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getRuleEngineSearchScopeWorkflowFactoryRuleEngine(
    requestParameters?: GetRuleEngineSearchScopeWorkflowFactoryRuleEngineParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EntitySearchScope>;
  public getRuleEngineSearchScopeWorkflowFactoryRuleEngine(
    requestParameters?: GetRuleEngineSearchScopeWorkflowFactoryRuleEngineParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EntitySearchScope>>;
  public getRuleEngineSearchScopeWorkflowFactoryRuleEngine(
    requestParameters?: GetRuleEngineSearchScopeWorkflowFactoryRuleEngineParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EntitySearchScope>>;
  public getRuleEngineSearchScopeWorkflowFactoryRuleEngine(
    requestParameters?: GetRuleEngineSearchScopeWorkflowFactoryRuleEngineParams,
    ...args: RequestArgs
  ): Observable<any> {
    const workflowFactoryType = requestParameters?.workflowFactoryType;
    this.checkRequired('getRuleEngineSearchScopeWorkflowFactoryRuleEngine', { workflowFactoryType });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/approval-workflows/workflow-factory/types/${this.configuration.encodeParam({ name: 'workflowFactoryType', value: workflowFactoryType, in: 'path', style: 'simple', explode: false, dataType: "'PositionRequest'", dataFormat: undefined })}/rule-engine/search-scope`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { searchQuery: requestParameters?.searchQuery }
    });
  }

  /**
   * Gets a page of workflow-factories.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pageWorkflowFactoriesWorkflowFactories(
    requestParameters?: PageWorkflowFactoriesWorkflowFactoriesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfWorkflowFactory>;
  public pageWorkflowFactoriesWorkflowFactories(
    requestParameters?: PageWorkflowFactoriesWorkflowFactoriesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfWorkflowFactory>>;
  public pageWorkflowFactoriesWorkflowFactories(
    requestParameters?: PageWorkflowFactoriesWorkflowFactoriesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfWorkflowFactory>>;
  public pageWorkflowFactoriesWorkflowFactories(
    requestParameters?: PageWorkflowFactoriesWorkflowFactoriesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/approval-workflows/workflow-factories`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TitleStartsWith: requestParameters?.titleStartsWith,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * Gets a page of workflow-factory-rules of a specific workflowFactoryId.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pageWorkflowFactoryRulesWorkflowFactoryRules(
    requestParameters?: PageWorkflowFactoryRulesWorkflowFactoryRulesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfWorkflowFactoryRule>;
  public pageWorkflowFactoryRulesWorkflowFactoryRules(
    requestParameters?: PageWorkflowFactoryRulesWorkflowFactoryRulesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfWorkflowFactoryRule>>;
  public pageWorkflowFactoryRulesWorkflowFactoryRules(
    requestParameters?: PageWorkflowFactoryRulesWorkflowFactoryRulesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfWorkflowFactoryRule>>;
  public pageWorkflowFactoryRulesWorkflowFactoryRules(
    requestParameters?: PageWorkflowFactoryRulesWorkflowFactoryRulesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const workflowFactoryId = requestParameters?.workflowFactoryId;
    this.checkRequired('pageWorkflowFactoryRulesWorkflowFactoryRules', { workflowFactoryId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/approval-workflows/workflow-factories/${this.configuration.encodeParam({ name: 'workflowFactoryId', value: workflowFactoryId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/rules`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TitleStartsWith: requestParameters?.titleStartsWith,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * Gets a page of workflow-steps of specific type.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pageWorkflowStepsWorkflowSteps(
    requestParameters?: PageWorkflowStepsWorkflowStepsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfWorkflowStep>;
  public pageWorkflowStepsWorkflowSteps(
    requestParameters?: PageWorkflowStepsWorkflowStepsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfWorkflowStep>>;
  public pageWorkflowStepsWorkflowSteps(
    requestParameters?: PageWorkflowStepsWorkflowStepsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfWorkflowStep>>;
  public pageWorkflowStepsWorkflowSteps(
    requestParameters?: PageWorkflowStepsWorkflowStepsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const type2 = requestParameters?.type2;
    const type = requestParameters?.type;
    this.checkRequired('pageWorkflowStepsWorkflowSteps', { type2 });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/approval-workflows/workflow-factory/types/${this.configuration.encodeParam({ name: 'type2', value: type, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/steps`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        type: requestParameters?.type,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public sendPositionRequestWorkflowBatchNotificationsWorkflowNotifications(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public sendPositionRequestWorkflowBatchNotificationsWorkflowNotifications(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public sendPositionRequestWorkflowBatchNotificationsWorkflowNotifications(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public sendPositionRequestWorkflowBatchNotificationsWorkflowNotifications(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/approval-workflow-notifications`,
      accepts: []
    });
  }

  /**
   * Updates the display name and GIDs of a configured \&#39;GidApprover\&#39; workflow-step.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateGidApproverWorkflowStepWorkflowSteps(
    requestParameters?: UpdateGidApproverWorkflowStepWorkflowStepsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<WorkflowStep>;
  public updateGidApproverWorkflowStepWorkflowSteps(
    requestParameters?: UpdateGidApproverWorkflowStepWorkflowStepsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<WorkflowStep>>;
  public updateGidApproverWorkflowStepWorkflowSteps(
    requestParameters?: UpdateGidApproverWorkflowStepWorkflowStepsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<WorkflowStep>>;
  public updateGidApproverWorkflowStepWorkflowSteps(
    requestParameters?: UpdateGidApproverWorkflowStepWorkflowStepsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const type = requestParameters?.type;
    this.checkRequired('updateGidApproverWorkflowStepWorkflowSteps', { id, type });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/approval-workflows/workflow-factory/types/${this.configuration.encodeParam({ name: 'type', value: type, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/steps/gid-approver-steps/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateGidApproverWorkflowStep,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Updates a workflow-factory-rule of a workflow-factory.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateWorkflowFactoryRuleWorkflowFactoryRules(
    requestParameters?: UpdateWorkflowFactoryRuleWorkflowFactoryRulesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PositionRequestWorkflowFactoryRule>;
  public updateWorkflowFactoryRuleWorkflowFactoryRules(
    requestParameters?: UpdateWorkflowFactoryRuleWorkflowFactoryRulesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PositionRequestWorkflowFactoryRule>>;
  public updateWorkflowFactoryRuleWorkflowFactoryRules(
    requestParameters?: UpdateWorkflowFactoryRuleWorkflowFactoryRulesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PositionRequestWorkflowFactoryRule>>;
  public updateWorkflowFactoryRuleWorkflowFactoryRules(
    requestParameters?: UpdateWorkflowFactoryRuleWorkflowFactoryRulesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const workflowFactoryId = requestParameters?.workflowFactoryId;
    const id = requestParameters?.id;
    this.checkRequired('updateWorkflowFactoryRuleWorkflowFactoryRules', { workflowFactoryId, id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/approval-workflows/workflow-factories/${this.configuration.encodeParam({ name: 'workflowFactoryId', value: workflowFactoryId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/rules/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.body,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Updates a workflow-factory.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateWorkflowFactoryWorkflowFactories(
    requestParameters?: UpdateWorkflowFactoryWorkflowFactoriesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<WorkflowFactory>;
  public updateWorkflowFactoryWorkflowFactories(
    requestParameters?: UpdateWorkflowFactoryWorkflowFactoriesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<WorkflowFactory>>;
  public updateWorkflowFactoryWorkflowFactories(
    requestParameters?: UpdateWorkflowFactoryWorkflowFactoriesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<WorkflowFactory>>;
  public updateWorkflowFactoryWorkflowFactories(
    requestParameters?: UpdateWorkflowFactoryWorkflowFactoriesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateWorkflowFactoryWorkflowFactories', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/approval-workflows/workflow-factories/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateWorkflowFactory,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
